import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
	createAccountFormValuesUpdated,
	attemptAccountCreation,
	accountCreationSuccess,
	accountCreationFailure,
} from '/common/reducers/createAccountFormReducer/createAccountFormReducerActions';
import Input from '/client/app/components/common/inputs/input/input';
import { createAccount } from '/client/app/api/backend';
import validator from 'validator';
import '/client/app/styles/controls.scss';
import './createAccountForm.scss';

class CreateAccountForm extends React.Component {
	constructor(props) {
		super(props);
		this.attemtAccountCreation = this.attemtAccountCreation.bind(this);
		this.onUsernameInput = this.onUsernameInput.bind(this);
		this.onEmailInput = this.onEmailInput.bind(this);
		this.onEmailConfirmationInput = this.onEmailConfirmationInput.bind(this);
		this.onPasswordInput = this.onPasswordInput.bind(this);
		this.onPasswordConfirmationInput = this.onPasswordConfirmationInput.bind(this);
		this.updateFormValues = this.updateFormValues.bind(this);
	}

	updateFormValues(changedValues) {
		const {
			email,
			emailError,
			username,
			usernameError,
			emailConfirmation,
			password,
			passwordError,
			passwordConfirmation,
			passwordConfirmationError,
			submitDisabled,
			submitButtonText,
			error,
			createAccountFormValuesUpdated: createAccountFormValuesUpdatedProp,
		} = this.props;
		const currentState = {
			email,
			emailError,
			username,
			usernameError,
			emailConfirmation,
			password,
			passwordError,
			passwordConfirmation,
			passwordConfirmationError,
			submitDisabled,
			submitButtonText,
			error,
		};
		const newValues = { ...currentState, ...changedValues };
		createAccountFormValuesUpdatedProp(
			newValues.username,
			newValues.email,
			newValues.emailError,
			newValues.emailConfirmation,
			newValues.emailConfirmationError,
			newValues.password,
			newValues.passwordError,
			newValues.passwordConfirmation,
			newValues.passwordConfirmationError,
			newValues.error
		);
	}

	onUsernameInput(e) {
		const usernameIsValid = e.target.value.trim().length > 0;
		const filteredUsername = e.target.value.replace(/[^\w\d_-]/, '');
		this.updateFormValues({
			username: filteredUsername,
			usernameError: usernameIsValid,
		});
	}

	onEmailInput(e) {
		const { emailConfirmation } = this.props;
		const emailIsInvalid = e.target.value.trim().length > 0 && !validator.isEmail(e.target.value.trim());
		const emailConfirmationIsInvalid = e.target.value.trim().length > 0 && e.target.value.trim() !== emailConfirmation;
		this.updateFormValues({
			email: e.target.value,
			emailError: emailIsInvalid,
			emailConfirmationError: emailConfirmationIsInvalid,
		});
	}

	onEmailConfirmationInput(e) {
		const { email } = this.props;
		const emailConfirmationIsInvalid = email.trim().length > 0 && email.trim() !== e.target.value.trim();
		this.updateFormValues({
			emailConfirmation: e.target.value,
			emailConfirmationError: emailConfirmationIsInvalid,
		});
	}

	onPasswordInput(e) {
		const { passwordConfirmation } = this.props;
		const passwordConfirmationIsInvalid = e.target.value.length > 0 && e.target.value !== passwordConfirmation;
		this.updateFormValues({
			password: e.target.value,
			passwordConfirmationError: passwordConfirmationIsInvalid,
		});
	}

	onPasswordConfirmationInput(e) {
		const { password } = this.props;
		const passwordConfirmationIsInvalid = password.length > 0 && password !== e.target.value.trim();
		this.updateFormValues({
			passwordConfirmation: e.target.value,
			passwordConfirmationError: passwordConfirmationIsInvalid,
		});
	}

	attemtAccountCreation(e) {
		e.preventDefault();

		const {
			username,
			password,
			email,
			destination,
			accountCreationFailure: accountCreationFailureProp,
			accountCreationSuccess: accountCreationSuccessProp,
			attemptAccountCreation: attemptAccountCreationProp,
		} = this.props;
		const trimmedEmail = email.trim();

		attemptAccountCreationProp();
		createAccount(username, trimmedEmail, password)
			.then((result) => {
				if (result === 'success') {
					accountCreationSuccessProp();
					window.location.href = destination;
				} else {
					accountCreationFailureProp(result);
				}
			})
			.catch((error) => {
				accountCreationFailureProp(error.message);
			});
		return false;
	}

	render() {
		const {
			username,
			usernameError,
			email,
			emailError,
			emailConfirmation,
			emailConfirmationError,
			password,
			passwordError,
			passwordConfirmation,
			passwordConfirmationError,
			submitDisabled,
			submitButtonText,
			error,
		} = this.props;

		return (
			<form className="createAccountForm" onSubmit={this.attemtAccountCreation}>
				<label htmlFor="username">username</label>
				<br />
				<Input
					type="text"
					id="username"
					name="username"
					placeholder="username"
					value={username}
					onChange={this.onUsernameInput}
					className={`createAccountFormField${usernameError ? ' createAccountFormFieldInError' : ''}`}
					required
				/>
				<br />
				<label htmlFor="email">email</label>
				<br />
				<Input
					type="text"
					id="email"
					value={email}
					name="email"
					placeholder="email address"
					onChange={this.onEmailInput}
					className={`createAccountFormField${emailError ? ' createAccountFormFieldInError' : ''}`}
					required
				/>
				<br />
				<label htmlFor="email2">confirm email</label>
				<br />
				<Input
					type="text"
					id="email2"
					name="email2"
					placeholder="confirm email"
					value={emailConfirmation}
					onChange={this.onEmailConfirmationInput}
					className={`createAccountFormField${emailConfirmationError ? ' createAccountFormFieldInError' : ''}`}
					required
				/>
				<br />
				<label htmlFor="password">password</label>
				<br />
				<Input
					type="password"
					id="password"
					name="password"
					placeholder="password"
					value={password}
					onChange={this.onPasswordInput}
					className={`createAccountFormField${passwordError ? ' createAccountFormFieldInError' : ''}`}
					required
				/>
				<br />
				<label htmlFor="password2">confirm password</label>
				<br />
				<Input
					type="password"
					id="password2"
					name="password2"
					placeholder="confirm password"
					value={passwordConfirmation}
					onChange={this.onPasswordConfirmationInput}
					className={`createAccountFormField${passwordConfirmationError ? ' createAccountFormFieldInError' : ''}`}
					required
				/>
				<br />
				<button
					className="standardButton createAccountButton"
					name="createAccountButton"
					type="submit"
					disabled={submitDisabled}
				>
					<b>{submitButtonText}</b>
				</button>
				<p className="createAccountErrorLabel">{error.toLowerCase()}</p>
			</form>
		);
	}
}

CreateAccountForm.propTypes = {
	email: PropTypes.string.isRequired,
	emailError: PropTypes.bool.isRequired,
	username: PropTypes.string.isRequired,
	usernameError: PropTypes.bool.isRequired,
	emailConfirmation: PropTypes.string.isRequired,
	emailConfirmationError: PropTypes.bool.isRequired,
	password: PropTypes.string.isRequired,
	passwordError: PropTypes.bool.isRequired,
	passwordConfirmation: PropTypes.string.isRequired,
	passwordConfirmationError: PropTypes.bool.isRequired,
	submitDisabled: PropTypes.bool.isRequired,
	submitButtonText: PropTypes.string.isRequired,
	error: PropTypes.string.isRequired,
	attemptAccountCreation: PropTypes.func.isRequired,
	accountCreationSuccess: PropTypes.func.isRequired,
	accountCreationFailure: PropTypes.func.isRequired,
	createAccountFormValuesUpdated: PropTypes.func.isRequired,
	destination: PropTypes.string.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
	createAccountFormValuesUpdated: (
		username,
		email,
		emailError,
		emailConfirmation,
		emailConfirmationError,
		password,
		passwordError,
		passwordConfirmation,
		passwordConfirmationError,
		error
	) =>
		dispatch(
			createAccountFormValuesUpdated(
				username,
				email,
				emailError,
				emailConfirmation,
				emailConfirmationError,
				password,
				passwordError,
				passwordConfirmation,
				passwordConfirmationError,
				error
			)
		),
	attemptAccountCreation: () => dispatch(attemptAccountCreation()),
	accountCreationSuccess: () => dispatch(accountCreationSuccess()),
	accountCreationFailure: (error) => dispatch(accountCreationFailure(error)),
});

export default connect(null, mapDispatchToProps)(CreateAccountForm);
